import { CU_COORDINATES, MX_COORDINATES, USA_COORDINATES } from 'constants/COORDINATES';

export const getDefaultCoordinatesByCountry = (region?: string): number[] => {
  switch (region || process.env.REACT_APP_ADDRESS_COUNTRY) {
    case 'CU':
      return CU_COORDINATES?.flatMap(({ lat, lng }) => [lng, lat]);
    case 'MX':
      return MX_COORDINATES?.flatMap(({ lat, lng }) => [lng, lat]);
    case 'US':
      return USA_COORDINATES?.flatMap(({ lat, lng }) => [lng, lat]);
    default:
      return [0, 0];
  }
};

export const getCoordinateByCountry = (coordinates: number[], region?: string) => {
  if (!coordinates || coordinates.length !== 2) {
    return {
      lat: 0,
      lng: 0,
    };
  }

  switch (region || process.env.REACT_APP_ADDRESS_COUNTRY) {
    case 'CU':
      return {
        lat: coordinates?.[1],
        lng: coordinates?.[0],
      };
    case 'MX':
      return {
        lat: coordinates?.[1],
        lng: coordinates?.[0],
      };
    case 'US':
      return {
        lat: coordinates?.[1],
        lng: coordinates?.[0],
      };
    default:
      return {
        lat: 0,
        lng: 0,
      };
  }
};
